export default "__VITE_ASSET__BXtRYQJH__"